var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckMarkSolidOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3996 5.36542C18.7501 5.58612 18.8554 6.04919 18.6347 6.39971L11.0791 18.3997C10.952 18.6017 10.7363 18.731 10.4983 18.7482C10.2603 18.7653 10.0283 18.6681 9.87353 18.4864L5.42908 13.2691C5.16048 12.9537 5.19835 12.4804 5.51366 12.2118C5.82898 11.9432 6.30234 11.981 6.57095 12.2964L10.3536 16.7368L17.3653 5.60049C17.586 5.24997 18.0491 5.14472 18.3996 5.36542Z",
    fill: "#FF5F14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMarkSolidOrange);
export default __webpack_public_path__ + "static/media/CheckMarkSolidOrange.d6940c5c77a9ddf1bf30a08946324009.svg";
export { ForwardRef as ReactComponent };